import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, PartnerOrderService } from 'app/services';
import { ExportFileExtension, ExportFileTypeEnum } from 'app/models';
import { Utils } from 'app/utils/utils';
import moment from 'moment';

@Component({
	selector: 'partner-insights-reports',
	templateUrl: './partner-insights-reports.component.html',
	styleUrls: [
		'./partner-insights-reports.component.scss',
		'../../../../../styles/m3-defaul-material-theme.scss',
	],
})
export class PartnerInsightsReportsComponent implements OnInit {
	public today: Date = new Date();
	public locationId: number = 0;
	public fromDate: Date = new Date(this.today.getTime() - 168 * 60 * 60 * 1000);
	public toDate: Date = new Date();

	public locations: Array<any> = [{ Id: 0, Name: 'All' }];
	public fileTypeOptions = ExportFileTypeEnum;

	constructor(
		public appData: AppDataService,
		private partnerOrderService: PartnerOrderService,
		private messageService: MessageService
	) {}

	ngOnInit() {
		this.getPartnerLocations();
	}

	private getPartnerLocations() {
		this.partnerOrderService
			.getPartnerLocations(this.messageService)
			.then((data) => {
				if (!data || !data.Items) {
					return;
				}

				if (!data.Success) {
					this.messageService.add({
						severity: 'error',
						summary: 'Error',
						detail: data.ErrorMessage,
					});
					return;
				}

				this.locations = this.locations.concat(data.Items);
			})
			.catch((err) => {
				throw err;
			});
	}

	public handleFilterChange(ev: any = null): void {
		if (ev && ev.value) {
			// Location changed, reload data
		}

		// The child components will handle their own data loading
		// when the input properties change
	}

	exportReport(fileType: ExportFileTypeEnum) {
		// Create export request with current filter parameters
		const request = {
			TimeZoneOffset: Utils.getTimezoneOffset(),
			LocationId: this.locationId === 0 ? undefined : this.locationId,
			FromDate: this.fromDate,
			ToDate: this.toDate,
			FileType: fileType,
			SearchName: '',
			Skip: 0,
			Take: 0, // 0 means get all records for export
			SortField: '',
			SortOrder: 1,
			HeaderColumns: [],
			DataColumns: [],
		};

		// Note: You'll need to implement the actual export service call
		// This is a placeholder implementation
		this.messageService.add({
			severity: 'info',
			summary: 'Export',
			detail: `Exporting insights report as ${ExportFileTypeEnum[fileType]}...`,
		});

		// TODO: Replace with actual service call when available
		// this.partnerInsightsService.exportInsightsReports(request, this.messageService)
		//     .then((data) => {
		//         this.messageService.add({
		//             severity: 'success',
		//             summary: 'Success',
		//             detail: 'Export completed successfully',
		//         });
		//         Utils.saveFileResponse(
		//             data,
		//             'InsightsReport' +
		//                 moment(new Date()).format('DD MMM YYYY hh:mm:ss A') +
		//                 ExportFileExtension[
		//                     ExportFileTypeEnum[fileType] as keyof typeof ExportFileExtension
		//                 ]
		//         );
		//     })
		//     .catch((err) => {
		//         this.messageService.add({
		//             severity: 'error',
		//             summary: 'Error',
		//             detail: 'Failed to export insights report',
		//         });
		//         throw err;
		//     });
	}
}
